import PopupSpeechBubbleBase, {
  SpeechBubbleCloseHandler,
} from './PopupSpeechBubbleBase';
import { View } from '@play-co/timestep-core/ui';

export default class PopupSpeechBubble extends PopupSpeechBubbleBase<void> {
  constructor(opts: {
    superview: View;
    close: SpeechBubbleCloseHandler<void>;
  }) {
    super({ ...opts, $subFeature: 'speech-bubble', closeAfterSkip: true });
  }
}
